import OutboundSsoLink from './OutboundSsoLink'

const outboundSsoModule = {
  SsoLink: OutboundSsoLink
}

export default outboundSsoModule
